import React from "react"
import Input from "semantic-ui-react/dist/es/elements/Input/Input"

function formatToDate(str) {
  return Array.from(str.split("/").join(""))
    .map((v, i) => {
      if (i === 2 || i === 4) {
        return `/${v}`
      }
      return v
    })
    .join("")
}
function getCorrectedYear(year) {
  if (year) {
    let correctedYear =
      (new Date().getFullYear() - (1900 + parseInt(year, 10)) < 85
        ? "19"
        : "20") +
      (year.length < 2 ? "0" : "") +
      year

    return correctedYear < new Date().getFullYear() ? correctedYear : year
  }
  return ""
}

export default class DatePicker extends React.Component {
  state = {
    date: ""
  }

  constructor(props) {
    super(props)
    this.state = {
      date: formatToDate(props.value ? props.value.replace(/\//g, "") : "")
    }
  }

  handleBlur = e => {
    const { value } = e.target
    const [month = "", day = "", year = ""] = formatToDate(value).split("/")
    const correctedYear = getCorrectedYear(year)

    this.setState({ date: formatToDate(`${month}${day}${correctedYear}`) })
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
    if (this.props.onChange) {
      this.props.onChange(e, {
        value: formatToDate(`${month}${day}${correctedYear}`)
      })
    }
  }
  handleOnChange = e => {
    const { value } = e.target
    let date = value.replace(/[^0-9/]/g, "")
    if (date.endsWith("/")) {
      if (date.match(/\//g).length <= 2) {
        date =
          date
            .split("/")
            .filter(a => a)
            .map(a => ("0" + a).slice(-2))
            .join("/") + "/"
      } else {
        date = date.slice(0, -1)
      }
    }
    if (date.split("/").join("").length === 8) {
      date = formatToDate(date)
    }
    this.setState({ date })
    if (this.props.onChange) {
      this.props.onChange(e, { value: formatToDate(date) })
    }
  }
  render = () => {
    return (
      <Input
        maxLength={10}
        value={this.state.date}
        placeholder="MM/DD/YYYY"
        onBlur={this.handleBlur}
        onChange={this.handleOnChange}
        error={this.props.error}
        autoComplete="off"
        name={this.props.name}
        type="text"
      />
    )
  }
}
